import { createReducer, on } from "@ngrx/store";
import { addTipoMonedas, addTipoMonedasError, clearTipoMonedas, deleteTipoMoneda, updateTipoMoneda } from "../actions/tipoMoneda.actions";
import { initialTipoMonedaState } from "../../core/interfaces/models/tipoMoneda.interface";


export const tipoMonedaReducer = createReducer(
  initialTipoMonedaState,
  on(addTipoMonedas, (_, { tipoMonedasState }) => (
    tipoMonedasState
  )),
  on(addTipoMonedasError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateTipoMoneda, (state, { tipoMoneda }) => ({
    ...state,
    tipoMonedas: state.tipoMonedas.map(u =>
      u.id === tipoMoneda.id ? tipoMoneda : u
    )
  })),
  on(deleteTipoMoneda, (state, { id }) => ({
    ...state,
    tipoMonedas: state.tipoMonedas.filter(u => u.id !== id)
  })),
  on(clearTipoMonedas, () => initialTipoMonedaState)
);
